import BetaFeatureSetting from './BetaFeatureSetting';

export default BetaFeatureSetting;
